import React from 'react';
import { ImageProxyContext } from '@common/context/ImageProxyContext';
import { ContentMessageServiceActions } from '../services/contentMessageServiceActions';
import { isExtensionContext } from '@common/services/detect-context';

export const ExtensionImageProxyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const processUrl = async (url: string) => {
        if (!url) return url;

        const shouldProxy =
            url.includes('blueticks-assets.storage.googleapis.com') || url.includes('googleapis.com');

        // Use proxy only when actually running as extension context.
        if (shouldProxy && isExtensionContext()) {
            try {
                const blobUrl = await ContentMessageServiceActions.fetchUrlContentAsBlob(url);
                // In some contexts messaging can return empty/undefined without throwing.
                // Keep original URL in that case.
                return blobUrl || url;
            } catch (e) {
                console.error("Failed to proxy image", e);
                return url;
            }
        }
        return url;
    };

    return (
        <ImageProxyContext.Provider value={{ processUrl }}>
            {children}
        </ImageProxyContext.Provider>
    );
};
